<mat-card>

  <mat-card-title>
    <h1>
      <span class="year"> {{kfConfiguration?.year}} </span><span> KF Configuration</span>
    </h1>
  </mat-card-title>

  <mat-card-content>

    <app-kf-configuration-edit-step-bar
      [currentStep]="currentStep"
      [selectedIndex]="stepper?.selectedIndex"
      [selectedIndex2]="stepper2?.selectedIndex"
      [step2Completed]="step2Completed"
      (loadStep)="loadStep($event)">
    </app-kf-configuration-edit-step-bar>

    <div class="wizard-content">
      <div *ngIf="currentStep == 0" class="step-container">
        <!--        <form [formGroup]="unuKeysFormGroup" (ngSubmit)="submitUNUKeysForm()">-->
        <div class="step-0">
          <label>
            You can manually configure the reporting groups and the groups definition or reuse the country
            configuration. Select an option:</label>
          <mat-radio-group #reuse_config_radio color="primary" [(ngModel)]="reuseOption">
            <mat-radio-button [value]="1">
              Create new configuration
            </mat-radio-button>
            <mat-radio-button [value]="2" [disabled]="!existReuseConfig">
              Reuse the {{schemaKind === 'COUNTRY' ? 'WEEE System': 'Country'}} configuration
            </mat-radio-button>
            <mat-radio-button [value]="3" [disabled]="!previousYears?.length">
              Reuse the configuration from a previous year
            </mat-radio-button>
          </mat-radio-group>

          <div *ngIf="reuseOption === 3" class="reuse-select">
            <p>To reuse the key figures configuration from a previous year, select the year below</p>
            <mat-form-field appearance="outline" color="primary">
              <mat-label> UNU-Keys sets</mat-label>
              <mat-select [(ngModel)]="yearToReuse">
                <mat-option [value]="year" *ngFor="let year of previousYears">{{year}}</mat-option>
              </mat-select>
              <mat-error>Please select a set</mat-error>
            </mat-form-field>
          </div>

          <div class="wizard-buttons-container align-right">
            <button mat-raised-button color="primary" (click)="initializeConfig()">
              <span>Save & Next</span>
              <mat-icon class="material-icons-outlined">chevron_right</mat-icon>
            </button>
          </div>
          <!--        </form>-->
        </div>

      </div>

      <div *ngIf="currentStep == 1" class="step-container">

        <h2
          *ngIf="stepper?.selectedIndex == 0">{{"country.kf-configuration.wizard.reporting-group.header" | translate}}</h2>
        <h2
          *ngIf="stepper?.selectedIndex == 1">{{"country.kf-configuration.wizard.reporting-group.header2" | translate}}</h2>
        <div *ngIf="allCategories?.content">
          <mat-stepper linear #stepper>
            <mat-step [editable]="true">
              <ng-template matStepLabel>Key Figures</ng-template>
              <h3>{{"country.kf-configuration.wizard.reporting-group.text1" | translate}} that WEEE Forum has
                provided</h3>
              <mat-card class="provider">
                <mat-card-content>{{kfConfiguration?.kfCategorySetName}}</mat-card-content>
              </mat-card>
              <h3>{{"country.kf-configuration.wizard.reporting-group.text1" | translate}}</h3>
              <app-kf-configuration-edit-table *ngIf="allCategories"
                                               [page]="allCategories.number"
                                               [pageSize]="allCategories.size"
                                               [totalElements]="allCategories.totalElements"
                                               [list]="allCategories.content"
                                               [selectedItems]="kfConfiguration?.keyFigureCategoriesIds"
                                               [type]="'KF-CATEGORIES'"
                                               (loadItems)="loadReportCycleCategories($event)"
                                               (addSelectedItem)="addSelectedCategory($event)"
                                               (removeSelectedItem)="removeSelectedCategory($event)">
              </app-kf-configuration-edit-table>
              <div class="wizard-buttons-container align-right">
                <button mat-raised-button (click)="currentStep = 0">
                  <mat-icon class="material-icons-outlined">chevron_left</mat-icon>
                  <span (click)="firstLoadCategoriesMapping = true; firstLoadCollectionStreamMapping = true">Back</span>
                </button>
                <button mat-raised-button matStepperNext color="primary" (click)="saveConfig()">
                  <span>Save & Next</span>
                  <mat-icon class="material-icons-outlined">chevron_right</mat-icon>
                </button>
              </div>
            </mat-step>
            <mat-step [editable]="true">
              <ng-template matStepLabel>Collection Streams</ng-template>
              <h3>{{"country.kf-configuration.wizard.reporting-group.text2" | translate}} that WEEE Forum has
                provided</h3>
              <mat-card class="provider">
                <mat-card-content>{{kfConfiguration?.collectionStreamName}}</mat-card-content>
              </mat-card>
              <h3>{{"country.kf-configuration.wizard.reporting-group.text2" | translate}}</h3>
              <app-kf-configuration-edit-table *ngIf="allCollectionStreams"
                                               [page]="allCollectionStreams.number"
                                               [pageSize]="allCollectionStreams.size"
                                               [totalElements]="allCollectionStreams.totalElements"
                                               [list]="allCollectionStreams.content"
                                               [type]="'COLLECTION-STREAMS'"
                                               [selectedItems]="kfConfiguration?.collectionStreamIds"
                                               (loadItems)="loadReportCycleCollectionStreams($event)"
                                               (addSelectedItem)="addSelectedCollectionStream($event)"
                                               (removeSelectedItem)="removeSelectedCollectionStream($event)">
              </app-kf-configuration-edit-table>
              <div class="wizard-buttons-container align-right">
                <button mat-raised-button matStepperPrevious>
                  <mat-icon class="material-icons-outlined">chevron_left</mat-icon>
                  <span>Back</span>
                </button>
                <button mat-raised-button color="primary" (click)="currentStep = 2;saveConfig()">
                  <span>Save & Next</span>
                  <mat-icon class="material-icons-outlined">chevron_right</mat-icon>
                </button>
              </div>
            </mat-step>
          </mat-stepper>
        </div>
      </div>

      <div *ngIf="currentStep == 2" class="step-container">
        <h2
          *ngIf="stepper2?.selectedIndex == 0">{{"country.kf-configuration.wizard.group-definition.header" | translate}}</h2>
        <h2
          *ngIf="stepper2?.selectedIndex == 1">{{"country.kf-configuration.wizard.group-definition.header2" | translate}}</h2>

        <mat-stepper linear #stepper2>
          <mat-step [editable]="true">
            <ng-template matStepLabel>Key Figures</ng-template>
            <app-kf-configuration-edit-drag-drop
              [unuKeyList]="unuKeys.content"
              [dropBoxes]="selectedCategories"
              [titleDropBoxes]="'Put On Market Categories'"
              [initialMapping]="categoriesInitialMapping"
              [initialMappingBeforeChanges]="categoriesInitialMappingBeforeChanges"
              [lifeCycleStatus]="kfConfiguration.lifeCycleStatus"
              (loadItems)="getSelectedCategories()"
              (previousStep)="currentStep = 1"
              (nextStep)="stepper2.next()"
              (saveMappings)="saveCategoriesMappings($event)">
            </app-kf-configuration-edit-drag-drop>
          </mat-step>
          <mat-step [editable]="true">
            <ng-template matStepLabel>Collection Streams</ng-template>
            <app-kf-configuration-edit-drag-drop
              [unuKeyList]="unuKeys.content"
              [dropBoxes]="selectedCollectionStreams"
              [titleDropBoxes]="'Collection Streams'"
              [initialMapping]="collectionStreamsInitialMapping"
              [initialMappingBeforeChanges]="collectionStreamsInitialMappingBeforeChanges"
              [lifeCycleStatus]="kfConfiguration.lifeCycleStatus"
              (loadItems)="getSelectedCollectionStreams()"
              (nextStep)="currentStep = 3; step2Completed = true"
              (saveMappings)="saveCollectionStreamMappings($event)">
            </app-kf-configuration-edit-drag-drop>
          </mat-step>
        </mat-stepper>
      </div>

      <div *ngIf="currentStep == 3" class="step-container">
        <div class="summary">
          <div class="summary-block">
            <h2>Reporting Groups</h2>
            <div class="summary-container">
              <div class="summary-button-container">
                <button mat-mini-fab color="primary" (click)="currentStep = 1; stepperIndex('stepper', 0)"> 1.1</button>
              </div>
              <div class="summary-text-container">
                <span>Key Figures</span>
              </div>
            </div>
            <div class="summary-container">
              <div class="summary-button-container">
                <button mat-mini-fab color="primary" (click)="currentStep = 1; stepperIndex('stepper', 1)"> 1.2</button>
              </div>
              <div class="summary-text-container">
                <span>Collection Streams</span>
              </div>
            </div>
          </div>

          <div>
            <h2>Groups Definition</h2>
            <div class="summary-container">
              <div class="summary-button-container">
                <button mat-mini-fab color="primary" (click)="currentStep = 2; stepperIndex('stepper2', 0)"> 2.1
                </button>
              </div>
              <div class="summary-text-container">
                <span>Key Figures</span>
              </div>
            </div>
            <div class="summary-container">
              <div class="summary-button-container">
                <button mat-mini-fab color="primary" (click)="currentStep = 2; stepperIndex('stepper2', 1)"> 2.2
                </button>
              </div>
              <div class="summary-text-container">
                <span>Collection Streams</span>
              </div>
            </div>
          </div>
        </div>

        <div class="align-right">
          <button mat-raised-button color="primary" (click)="launchReport()">
            <span>Launch</span>
            <mat-icon class="material-icons-outlined">launch</mat-icon>
          </button>
        </div>
      </div>

    </div>
  </mat-card-content>
</mat-card>
